const BASE_DOMAIN = import.meta.env.VITE_BASE_DOMAIN || 'umkmindonesia.my.id'

/** Subdomain katalog Premium, mis. namatoko.umkmindonesia.my.id */
export function getSubdomainFromHost(hostname = window.location.hostname): string | null {
  if (!hostname || hostname === 'localhost' || hostname === '127.0.0.1') return null

  const parts = hostname.split('.')
  if (parts.length < 3) return null

  const baseParts = BASE_DOMAIN.split('.')
  const suffix = parts.slice(-baseParts.length).join('.')
  if (suffix !== BASE_DOMAIN) return null

  const sub = parts.slice(0, -baseParts.length).join('.')
  if (!sub || sub === 'www') return null

  return sub
}

export function getSubdomainCatalogUrl(subdomainKey: string): string {
  if (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
    return `${window.location.origin}/catalog/${subdomainKey}`
  }
  return `https://${subdomainKey}.${BASE_DOMAIN}`
}

export function getCanonicalCatalogUrl(slug: string, preferSubdomain = false): string {
  if (preferSubdomain) return getSubdomainCatalogUrl(slug)
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/catalog/${slug}`
  }
  return `https://${BASE_DOMAIN}/catalog/${slug}`
}
